import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductRefundDocument.Save.IRequest;
type Response = Api.Core.ProductRefundDocument.Save.IResponse;
type Headers = Api.Core.ProductRefundDocument.Save.IHeaders;
const url = '/api/ProductManagement/ProductRefundDocument/:productId';
export default async function productRefundDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { productId: body?.productId, documentId: body?.id }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
